import log from 'salvo-lite/log'
import scrollToElement from 'scroll-to-element'

class ScrollTo {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            targetElem: 'html',
            offset: -80,
            mobOffset: -80,
            duration: 750,
            ...JSON.parse(elem.getAttribute('data-scroll-to') || '{}')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._elem.addEventListener('click', () => {
            if (window.innerWidth > 1440) {
                scrollToElement(this._data.targetElem, {
                    offset: this._data.offset,
                    duration: this._data.duration
                })
            } else {
                scrollToElement(this._data.targetElem, {
                    offset: this._data.mobOffset,
                    duration: this._data.duration
                })
            }
        })
    }
}

export default ScrollTo



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ScrollTo.js